/** 点赞/收藏展示：≤1000 原样，>1000 用 k（如 1300 → 1.3k） */
export function formatViewpointEngagementCount(count: number): string {
  const n = Math.max(0, Math.floor(Number.isFinite(count) ? count : 0));
  if (n <= 1000) {
    return String(n);
  }
  const k = n / 1000;
  if (Math.abs(k - Math.round(k)) < 0.05) {
    return `${Math.round(k)}k`;
  }
  return `${k.toFixed(1)}k`;
}
